<script>
import { orderReportMethods } from '@state/helpers'

export default {
  props: {
    customerId: {
      type: [Number, String],
      default: '',
    },
    customerUserId: {
      type: [Number, String],
      default: '',
    },
    productId: {
      type: [Number, String],
      default: '',
    },
    productAddOns: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      routePath: 'orderreport',
      companyName: '',
      state: '',
      cityName: '',
      firstName: '',
      middleName: '',
      lastName: '',
      coFirstName: '',
      coMiddleName: '',
      coLastName: '',
      coSSN: '',
      coDateOfbirth: '',
      coStreetAddress: '',
      coCityName: '',
      coState: '',
      coZip: '',
      phoneValue: 0,
      phoneNumber: '',
      rptBusinesId: '',
      address: '',
      streetAddress: '',
      zipValue: 0,
      zip: '',
      ssn: '',
      loanIdentifier: '',
      businessname: '',
      dateOfbirth: '',
      legaldescription: '',
      hideAdvancedSearch: false,
      coborrower: false,
      headeTitle: 'Order Report',
      FormSecondTitle: 'Search',
      signedfile: null,
      showSpinner: false,
      showAlert: false,
      alertMessage: '',
      disableText: false,
      eSigned: true,
      showPreAddress: false,
      taxyear: [],
      taxtype: '',
      taxform: '',
      customerList: [],
      chooseProductList: [],
      customerUserList: [],
      reportType: 'P',
      maxbirtdate: '',
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'Order Report',
          active: true,
        },
      ],
      typeOption: [
        { text: 'Personal', value: 'P' },
        { text: 'Business', value: 'B' },
      ],
      stateDetails: [
        { text: 'Alaska', value: '1' },
        { text: 'Arizona', value: '2' },
      ],
      taxTableData: [
        {
          taxformcol: [
            { text: '1040 Primary or Joint', value: '1040 Primary or Joint' },
            { text: '1040 Spouse', value: '1040 Spouse' },
            { text: 'W2 Primary', value: 'W2 Primary' },
            { text: 'W2 Spouse', value: 'W2 Spouse' },
            { text: '1099 Primary', value: '1099 Primary' },
            { text: '1099 Spouse', value: '1099 Spouse' },
          ],
          taxtypecol: [
            { text: '6b Return Transcript', value: '6b Return Transcript' },
            { text: '6b Account Transcript', value: '6b Account Transcript' },
            {
              text: '6b Record of Transcript',
              value: '6b Record of Transcript',
            },
          ],
          taxyearcol: [
            {
              text: '2019',
              value: '2019',
              checked: true,
              disabled: false,
            },
            {
              text: '2018',
              value: '2018',
              checked: false,
              disabled: false,
            },
            {
              text: '2017',
              value: '2017',
              checked: true,
              disabled: false,
            },
            {
              text: '2016',
              value: '2016',
              checked: false,
              disabled: false,
            },
          ],
          actions: false,
        },
      ],
      taxColumnsDefinition: [
        { key: 'taxformcol', label: 'Tax Form', sortable: false },
        { key: 'taxtypecol', label: 'Transcript Type', sortable: false },
        { key: 'taxyearcol', label: 'Tax Year', sortable: false },
        { key: 'actions', label: 'Actions', sortable: false },
      ],
    }
  },
  computed: {
    placeholders() {
      // return process.env.NODE_ENV === 'production'
      //   ? {}
      //   : {
      return {
        companyName: 'Company Name',
        state: 'Select State',
        cityName: 'City Name',
        firstName: 'First Name',
        lastName: 'Last Name',
        rptBusinesId: 'Business ID',
        businessname: 'Business Name',
        legaldescription: 'Legal Description',
        dateOfbirth: 'DD/MM/YYYY',
        phoneNumber: '(xxx) xxx-xxxx',
        address: 'Address here',
        ssn: 'xxx-xxx-xxxx',
        streetAddress: 'Street Address',
        zip: 'xxxxx-xxxx',
        loanIdentifier: 'Loan Identifier',
        middleName: 'Middle Name',
      }
    },
  },
  mounted() {
    this.getMaxDateLimit()
  },
  inject: ['$validator'],
  methods: {
    ...orderReportMethods,
    toggleEventParent: function() {
      this.coborrower = !this.coborrower
    },
    focusOut: function(event) {
      if (['Arrow', 'Backspace', 'Shift'].includes(event.key)) {
        this.preventNextIteration = true
        return
      }
      if (this.preventNextIteration) {
        this.preventNextIteration = false
        return
      }
      this.phoneValue = event.target.value // this.phoneNumber
        .replace(/[^0-9]/g, '')
        .match(/(\d{1,10})/g)[0]

      // Format display value based on calculated currencyValue
      event.target.value = this.phoneValue.replace(
        /(\d{3})(\d{3})(\d{4})/,
        '($1) $2-$3'
      )
    },
    focusOutZip: function(event) {
      if (['Arrow', 'Backspace', 'Shift'].includes(event.key)) {
        this.preventNextIteration = true
        return
      }
      if (this.preventNextIteration) {
        this.preventNextIteration = false
        return
      }
      this.zipValue = event.target.value
        .replace(/[^0-9]/g, '')
        .match(/(\d{1,10})/g)[0]

      // /^[0-9]{5}(?:-[0-9]{4})?$/

      // Format display value based on calculated currencyValue
      event.target.value = this.zipValue.replace(/(\d{5})(\d{4})/, '$1-$2')
    },

    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxbirtdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },

    onAddTaxRow() {
      if (this.taxTableData.length < 4) {
        this.taxTableData.push(this.taxTableData[0])
      }
    },
    onDelTaxRow(event) {
      if (this.taxTableData.length > 1) {
        this.taxTableData.splice(1, 1)
      }
    },
    onTrvReportSubmit(selectedValue) {
      // console.log('Child..')
      // this.$emit('onFetchData', selectedValue)
      console.log(this.productId)
      var parentValidation = false
      var childvalidation = false
      this.currentUserId = this.$store.state.auth.currentUser.userInfo.userID
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        console.log('Parent Comp', response)
        parentValidation = response
        this.$validator.validate().then((response) => {
          // console.log('Inner Comp', response)
          childvalidation = response
          if (parentValidation && childvalidation) {
            that.showSpinner = true
            that
              .fetchOrderReport({
                userId: that.currentUserId,
                stateCode: 'CA',
                customerId: that.customerId,
                customerUserId: that.customerUserId,
                productId: that.productId,
                loanIdentifier: that.loanIdentifier,
                firstName: that.firstName,
                middleName: that.middleName,
                lastName: that.lastName,
                street: that.streetAddress,
                city: that.cityName,
                stateId: that.state,
                zip: that.zip,
                buisnessName: that.businessname,
                phoneNumber: that.phoneNumber,
                legalDescription: that.legaldescription,
                isCoBorrower: that.coborrower,
                coFirstName: that.coFirstName,
                coMiddleName: that.coMiddleName,
                coLastName: that.coLastName,
              })
              .then((response) => {
                that.$router.push({
                  name: 'orderreport',
                  params: {
                    resultMessage: response.data.message,
                    showMessage: true,
                  },
                })
                that.showSpinner = false
              })
              .catch((error) => {
                that.showSpinner = false
                alert(error)
              })
          }
        })
      })
    },
    onChangeTaxYear(event) {
      console.log('checkbox ->', event)
    },
  },
}
</script>

<template>
  <div>
    <BaseSpinner v-if="showSpinner" />
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="loanIdentifier"
          v-model="loanIdentifier"
          v-validate="'required'"
          type="text"
          maxlength="50"
          name="loanIdentifier"
          label-content="Loan Identifier"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('loanIdentifier'),
          }"
          :placeholder="placeholders.loanIdentifier"
        ></BaseEInputText>
        <div v-show="errors.has('loanIdentifier')" class="error">
          Loan Identifier is required
        </div>
      </b-col>
      <b-col md="6">
        <BaseELabel label="Type" />
        <b-form-group>
          <b-form-radio-group
            :key="typeOption.id"
            v-model="reportType"
            :options="typeOption"
            class="mr-5"
            @change.native="emailValidate($event.target.value)"
          />
        </b-form-group>
      </b-col>
      <b-col offset="1"></b-col>
      <b-col md="12" class="border-bottom pb-3" />
    </b-row>
    <div v-if="reportType === 'P'">
      <b-row>
        <b-col md="3">
          <BaseEInputText
            id="firstName"
            v-model="firstName"
            v-validate="'required'"
            type="text"
            name="firstName"
            maxlength="50"
            label-content="First Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('firstName'),
            }"
            :placeholder="placeholders.firstName"
          ></BaseEInputText>
          <div v-show="errors.has('firstName')" class="error">
            First Name is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="middleName"
            v-model="middleName"
            type="text"
            name="middleName"
            maxlength="50"
            label-content="Middle Name"
            :class="{
              input: true,
              'is-danger': errors.has('middleName'),
            }"
            :placeholder="placeholders.middleName"
          ></BaseEInputText>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="lastName"
            v-model="lastName"
            v-validate="'required'"
            type="text"
            name="lastName"
            maxlength="50"
            label-content="Last Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('lastName'),
            }"
            :placeholder="placeholders.lastName"
          ></BaseEInputText>
          <div v-show="errors.has('lastName')" class="error">
            Last Name is required
          </div>
        </b-col>
        <b-col md="3"></b-col>
        <b-col md="3">
          <BaseEInputText
            id="ssn"
            v-model="ssn"
            type="text"
            maxlength="10"
            name="ssn"
            label-content="SSN"
            :class="{
              input: true,
              'is-danger': errors.has('ssn'),
            }"
            :placeholder="placeholders.ssn"
            @keyup="focusOut"
          ></BaseEInputText>
          <div v-show="errors.has('ssn')" class="error">
            SS Number is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel label="Date of Birth" />
          <BaseDate
            id="dateOfbirth"
            v-model="dateOfbirth"
            type="date"
            :field-id="dateOfBirth"
            name="dateOfBirth"
            data-vv-as="Date of Birth"
            :max="maxbirtdate"
            :class="{
              input: true,
              'is-danger': errors.has('dateOfBirth'),
            }"
          ></BaseDate>
          <div class="error">
            {{ errors.first('dateOfBirth') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="phoneNumber"
            v-model="phoneNumber"
            type="text"
            maxlength="10"
            name="phoneNumber"
            label-content="Phone Number"
            :class="{
              input: true,
              'is-danger': errors.has('phoneNumber'),
            }"
            :placeholder="placeholders.phoneNumber"
            @keyup="focusOut"
          ></BaseEInputText>
          <div v-show="errors.has('phoneNumber')" class="error">
            Phone Number is required
          </div>
        </b-col>
        <b-col md="3"></b-col>
      </b-row>
    </div>
    <div v-if="reportType === 'B'">
      <b-row>
        <b-col md="3">
          <div>
            <BaseEInputText
              id="rptBusinesId"
              v-model="rptBusinesId"
              v-validate="'required'"
              type="text"
              name="rptBusinesId"
              maxlength="100"
              label-content="Business ID"
              mark-required
              :class="{
                input: true,
                'is-danger': errors.has('rptBusinesId'),
              }"
              :placeholder="placeholders.rptBusinesId"
            ></BaseEInputText>
            <div v-show="errors.has('rptBusinesId')" class="error">
              Business ID is required
            </div>
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="businessname"
            v-model="businessname"
            v-validate="'required'"
            type="text"
            name="businessname"
            maxlength="100"
            label-content="Business Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('businessname'),
            }"
            :placeholder="placeholders.businessname"
          ></BaseEInputText>
          <div v-show="errors.has('businessname')" class="error">
            Business Name is required
          </div>
        </b-col>
        <b-col md="6"></b-col>
      </b-row>
    </div>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="streetAddress"
          v-model="streetAddress"
          v-validate="'required'"
          type="text"
          name="streetAddress"
          maxlength="100"
          label-content="Street"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('streetAddress'),
          }"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div v-show="errors.has('streetAddress')" class="error">
          Street is required
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="'required'"
          type="text"
          name="cityName"
          maxlength="20"
          label-content="City"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('cityName'),
          }"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div v-show="errors.has('cityName')" class="error">
          City is required
        </div>
      </b-col>
      <b-col md="3">
        <BaseELabel mark-required label="State" />
        <BaseDropdown
          v-model="state"
          v-validate="'required'"
          :field-id="state"
          :options="stateDetails"
          class="mb-1"
          name="state"
          :placeholder="placeholders.state"
        ></BaseDropdown>
        <div v-show="errors.has('state')" class="error">
          State is required
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="zip"
          v-model="zip"
          type="text"
          maxlength="9"
          name="zip"
          label-content="Zip"
          :class="{
            input: true,
            'is-danger': errors.has('zip'),
          }"
          :placeholder="placeholders.zip"
          @keyup="focusOutZip"
        ></BaseEInputText>
        <div v-show="errors.has('zip')" class="error">
          Zip is required
        </div>
      </b-col>
      <b-col offset="9"></b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="link" :pressed.sync="showPreAddress">
          <span v-if="!showPreAddress" :class="$style.linkStyle"
            >+ Add Previous Address</span
          >
          <span v-if="showPreAddress" :class="$style.linkStyle"
            >- Remove Previous Address</span
          >
        </b-button>
      </b-col>
    </b-row>
    <div v-if="showPreAddress">
      <b-row>
        <b-col md="3">
          <BaseEInputText
            id="preStreetAddress"
            v-model="preStreetAddress"
            v-validate="'required'"
            type="text"
            name="preStreetAddress"
            maxlength="100"
            label-content="Street"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('preStreetAddress'),
            }"
            :placeholder="placeholders.streetAddress"
          ></BaseEInputText>
          <div v-show="errors.has('preStreetAddress')" class="error">
            Street is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="preCityName"
            v-model="preCityName"
            v-validate="'required'"
            type="text"
            name="preCityName"
            maxlength="20"
            label-content="City"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('preCityName'),
            }"
            :placeholder="placeholders.cityName"
          ></BaseEInputText>
          <div v-show="errors.has('preCityName')" class="error">
            City is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel mark-required label="State" />
          <BaseDropdown
            v-model="preState"
            v-validate="'required'"
            :field-id="preState"
            :options="stateDetails"
            class="mb-1"
            name="preState"
            :placeholder="placeholders.state"
          ></BaseDropdown>
          <div v-show="errors.has('preState')" class="error">
            State is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="preZip"
            v-model="preZip"
            type="text"
            maxlength="9"
            name="preZip"
            label-content="Zip"
            :class="{
              input: true,
              'is-danger': errors.has('preZip'),
            }"
            :placeholder="placeholders.zip"
            @keyup="focusOutZip"
          ></BaseEInputText>
          <div v-show="errors.has('preZip')" class="error">
            Zip is required
          </div>
        </b-col>
        <b-col offset="9"></b-col>
      </b-row>
    </div>
    <b-row class="mt-3">
      <!-- <b-col md="1">
        <BaseButton
          type="button"
          size="sm"
          pill
          :class="$style.btnHover"
          name="search"
          @click="onAddTaxRow"
          >+ Add Row
        </BaseButton>
      </b-col> -->
      <b-col>
        <BaseEButton pill size="sm" class="ml-4" @click="onAddTaxRow"
          >+ Add Row</BaseEButton
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-1">
        <div class="text-center">
          <b-table
            id="taxTabel"
            hover
            striped
            bordered
            :items="taxTableData"
            :fields="taxColumnsDefinition"
          >
            <template v-slot:cell(taxformcol)="row">
              <BaseDropdown
                v-model="taxform[row.index]"
                v-validate="'required'"
                :field-id="taxform[row.index]"
                :options="row.item.taxformcol"
                class="pt-1"
                name="taxform"
              ></BaseDropdown>
              <div v-show="errors.has('taxform')" class="error">
                Taxform is required
              </div>
            </template>
            <template v-slot:cell(taxtypecol)="row">
              <BaseDropdown
                v-model="taxtype[row.index]"
                v-validate="'required'"
                :field-id="taxtype[row.index]"
                :options="row.item.taxtypecol"
                class="pt-1"
                name="taxtype"
              ></BaseDropdown>
              <div v-show="errors.has('taxtype')" class="error">
                Taxtype is required
              </div>
            </template>
            <template v-slot:cell(taxyearcol)="row">
              <b-form-group class="pt-2 mb-0 align-self-center">
                <b-form-checkbox
                  v-for="option in row.item.taxyearcol"
                  :key="option.value"
                  v-model="taxyear[row.index]"
                  v-validate="'required'"
                  :value="option.value + [row.index]"
                  :checked="option.checked"
                  :disabled="option.disabled"
                  class="col-2"
                  name="taxyear[row.index]"
                  inline
                  >{{ option.text }}
                  {{ option.value + [row.index] }}</b-form-checkbox
                >
              </b-form-group>
              <div v-show="errors.has('taxyear')" class="error"
                >Taxyear is required</div
              >
            </template>
            <template v-slot:cell(actions)="row">
              <b-form-group class="pt-2 text-center">
                <BaseIcon
                  v-model="row.item.actions"
                  name="times-circle"
                  :class="$style.delActionBtn"
                  @click="onDelTaxRow"
                />
              </b-form-group>
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="border-bottom" />
      <b-col md="4">
        <BaseELabel mark-required label="Upload Signed 4506T form" />
        <BaseFormfileInput
          id="signedfile"
          v-model="signedfile"
          v-validate="'required'"
          placeholder="example_filename.pdf"
          drop-placeholder="Drop file here..."
          class="mb-1"
        ></BaseFormfileInput>
        <div v-show="errors.has('signedfile')" class="error">
          Signed 4506T form is required
        </div>
        <!-- <div class="mt-3">Selected file: {{ signedfile ? signedfile.name : '' }}</div> -->
      </b-col>
      <b-col md="4" class="align-self-center">
        <b-form-checkbox
          :key="true"
          v-model="eSigned"
          class="pt-4"
          :value="true"
          :checked="true"
          :disabled="false"
          name="eSigned"
          inline
          >{{ 'Is 4506T Electronically signed?' }}</b-form-checkbox
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col offset="9"></b-col>
      <b-col md="3">
        <BaseELabel label="Co-Borrower" />
        <BaseSwitch
          id="coborrower"
          v-model="coborrower"
          name="coborrower"
          class="float-left pt-2"
          :is-checked="false"
          @toggleEvent="toggleEventParent"
        />
        <span v-if="coborrower" :class="$style.statusCheck">Yes</span>
        <span v-else :class="$style.statusCheck">No</span>
      </b-col>
    </b-row>
    <div v-if="coborrower === true">
      <b-row>
        <b-col md="12" class="border-bottom pb-3" />
        <b-col md="3">
          <BaseEInputText
            id="coFirstName"
            v-model="coFirstName"
            v-validate="'required'"
            type="text"
            name="coFirstName"
            maxlength="50"
            label-content="First Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('coFirstName'),
            }"
            :placeholder="placeholders.firstName"
          ></BaseEInputText>
          <div v-show="errors.has('coFirstName')" class="error">
            First Name is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="coMiddleName"
            v-model="coMiddleName"
            type="text"
            name="coMiddleName"
            maxlength="50"
            label-content="Middle Name"
            :class="{
              input: true,
              'is-danger': errors.has('middleName'),
            }"
            :placeholder="placeholders.middleName"
          ></BaseEInputText>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="coLastName"
            v-model="coLastName"
            v-validate="'required'"
            type="text"
            name="coLastName"
            maxlength="50"
            label-content="Last Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('coLastName'),
            }"
            :placeholder="placeholders.lastName"
          ></BaseEInputText>
          <div v-show="errors.has('coLastName')" class="error">
            Last Name is required
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <BaseEInputText
            id="coSSN"
            v-model="coSSN"
            v-validate="'required'"
            type="text"
            maxlength="10"
            name="coSSN"
            label-content="SSN"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('coSSN'),
            }"
            :placeholder="placeholders.ssn"
            @keyup="focusOut"
          ></BaseEInputText>
          <div v-show="errors.has('coSSN')" class="error">
            SS Number is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="coDateOfbirth"
            v-model="coDateOfbirth"
            type="text"
            maxlength="10"
            name="coDateOfbirth"
            label-content="DOB"
            :class="{
              input: true,
              'is-danger': errors.has('coDateOfbirth'),
            }"
            :placeholder="placeholders.dateOfbirth"
          ></BaseEInputText>
          <div v-show="errors.has('coDateOfbirth')" class="error">
            Date of Birth is required
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <BaseEInputText
            id="coStreetAddress"
            v-model="coStreetAddress"
            v-validate="'required'"
            type="text"
            name="coStreetAddress"
            maxlength="100"
            label-content="Street"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('coStreetAddress'),
            }"
            :placeholder="placeholders.streetAddress"
          ></BaseEInputText>
          <div v-show="errors.has('coStreetAddress')" class="error">
            Street is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="coCityName"
            v-model="coCityName"
            v-validate="'required'"
            type="text"
            name="coCityName"
            maxlength="20"
            label-content="City"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('coCityName'),
            }"
            :placeholder="placeholders.cityName"
          ></BaseEInputText>
          <div v-show="errors.has('coCityName')" class="error">
            City is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel mark-required label="State" />
          <BaseDropdown
            v-model="coState"
            v-validate="'required'"
            :field-id="coState"
            :options="stateDetails"
            class="mb-1"
            name="coState"
            mark-required
            :placeholder="placeholders.state"
          ></BaseDropdown>
          <div v-show="errors.has('coState')" class="error">
            State is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="coZip"
            v-model="coZip"
            type="text"
            maxlength="9"
            name="coZip"
            label-content="Zip"
            :class="{
              input: true,
              'is-danger': errors.has('coZip'),
            }"
            :placeholder="placeholders.zip"
            @keyup="focusOutZip"
          ></BaseEInputText>
          <div v-show="errors.has('coZip')" class="error">
            Zip is required
          </div>
        </b-col>
      </b-row>
    </div>
    <b-row class="mt-4" align-h="center">
      <b-col md="1" class="p-0">
        <BaseEButton type="button" name="search" @click="onTrvReportSubmit">
          Submit
        </BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.status {
  margin: 0.625rem 0;
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}
.labelHeader {
  font-size: $size-font-sub-header;
  font-weight: $heading-font-weight;
  color: $color-subheader;
}

.statusCheck {
  position: relative;
  top: 8px;
  padding-left: 11px;
  font-size: 16px;
  font-weight: bold;
  color: dodgerblue;
}
.delActionBtn {
  font-size: 1.2rem;
  color: $color-button-bg !important;
  vertical-align: middle;
}
.linkStyle {
  font-weight: bold;
  color: $color-button-bg !important;
}
</style>
